export default {
  talk_to_us: 'Tal med os:',
  send_us_email: 'Send os en e-mail:',
  visit_website: 'Besøg vores hjemmeside:',
  join_our_community: 'Bliv en del af vores fællesskab for eksklusive tilbud og nyheder!',
};
